import { api } from "@/http/api-client"

export interface IUpdateAccountParams {
  accountId: string
  organizationSlug: string
  name: string
}

export async function updateAccount(params: IUpdateAccountParams) {
  const { accountId, organizationSlug, name } = params
  const searchParams = new URLSearchParams()
  searchParams.append("organizationSlug", organizationSlug)

  return api.put(`/finances/accounts/${accountId}?${searchParams.toString()}`, {
    json: { name },
  })
}
